import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { DialogComponent } from './dialog.component';
import { LcsDialogService } from './dialog.service';

@NgModule({
   declarations: [DialogComponent],
   exports: [DialogComponent],
   imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, LcsLoadingOverlayModule],
   providers: [LcsDialogService],
})
export class DialogModule {}
